/*eslint-disable */
import _ from 'lodash';
import {LEGAL_FIRMS_UPDATED} from '../../mutation-types';

export default {
    [LEGAL_FIRMS_UPDATED](state, ui) {
        state.items = _.unionBy(ui, state.items, "id");
    }
};
